import MultipleChoiceSetting from "./KrMultipleChoiceSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrMultipleChoiceSetting = install(MultipleChoiceSetting); // 生成带有 install 方法的组件

export default KrMultipleChoiceSetting;
